import { bool, func, string, element, oneOfType } from 'prop-types';

import React from 'react';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import LoadingButton from 'components/shared/LoadingButton/LoadingButton';

const SaveButtonWithPermissions = WithUserPermissions(LoadingButton);

const SaveLoadingButtonWithPermissions = ({
  children,
  className,
  disabled,
  id,
  dataTestId,
  onClick,
  requestStatusKey,
  shouldDisable
}) => {
  return (
    <SaveButtonWithPermissions
      className={className}
      disabled={disabled}
      id={id}
      data-testid={dataTestId}
      onClick={onClick}
      requestStatusKey={requestStatusKey}
      shouldDisable={shouldDisable}>
      {children}
    </SaveButtonWithPermissions>
  );
};

SaveLoadingButtonWithPermissions.propTypes = {
  children: oneOfType([string, element]).isRequired,
  className: string.isRequired,
  disabled: bool,
  onClick: func.isRequired,
  requestStatusKey: string.isRequired,
  shouldDisable: bool
};

export default SaveLoadingButtonWithPermissions;
